










import Vue from 'vue';

export default Vue.extend({
  name: 'BaseInput',
  props: {
    value: String,
  },
  methods: {
    handleInput(event: any): void {
      this.$emit('input', event.target.value);
    },
    handleBlur(event: any): void {
      this.$emit('blur', event.target.value);
    },
    handleEnter(event: any): void {
      this.$emit('submit', event.target.value);
    },
  },
});
